<template>
  <div>
    <CreateEditModuleModal
      v-if="showCreateEditModuleModal"
      :courseId="courseId"
      :moduleId="moduleIdSelected"
      @closeModal="closeCreateEditModuleModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else>
      <div class="card">
        <div class="card-header d-flex align-items-center py-0">
          <h6 class="py-3 mb-0">Módulos do Curso</h6>
          <div class="ms-auto">
            <button
              v-if="courseSelected.status == 2"
              type="button"
              class="btn btn-primary"
              title="Cadastrar Módulo"
              @click="createEditModule()"
            >
              Cadastrar Módulo
            </button>
          </div>
        </div>
        <div v-if="modules.length == 0" class="card-body text-center">
          <p class="mb-0">Este curso não possui nenhum módulo cadastrado</p>
        </div>
      </div>
      <ListModules
        v-if="modules.length > 0"
        :modules="modules"
        @editModule="createEditModule"
      />
    </div>
  </div>
</template>

<script>
import CreateEditModuleModal from '@/components/courses/modules/CreateEditModuleModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListModules from '@/components/courses/modules/ListModules.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ModulesCourse',

  components: {
    CreateEditModuleModal,
    LoadingData,
    ListModules,
  },

  props: {
    courseId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditModuleModal: false,
      modules: [],
      moduleIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['courseSelected']),
  },

  methods: {
    async getModules() {
      try {
        const response = await this.$store.dispatch('getModules', this.courseId)

        this.modules = []

        response.forEach((module) => {
          this.modules.push({
            ...module,
            showLesson: false,
          })
        })

        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditModule(moduleId) {
      this.moduleIdSelected = moduleId || null
      this.showCreateEditModuleModal = true
    },

    closeCreateEditModuleModal(loadListModules) {
      if (loadListModules) {
        this.getModules()
      }
      this.showCreateEditModuleModal = false
    },
  },

  mounted() {
    this.getModules()
  },
}
</script>
